export const getStatusStyle = (status) => {
    switch (status) {
      case 'Booked': return { backgroundColor: '#E0F2FE', color: '#3B82F6' };
      case 'Reserved': return { backgroundColor: '#FFFBEB', color: '#D97706' };
      case 'Cancelled': return { backgroundColor: '#FEE2E2', color: '#B91C1C' };
      case 'New': return { backgroundColor: '#E0F7FA', color: '#00BCD4' };
      default: return {};
    }
};

export const styles = {
    appContainer: { 
        display: 'flex', 
        minHeight: '100vh', 
        backgroundColor: '#F9FAFB',
        width: '100%',
        position: 'relative'
    },
    mainContent: { 
        flex: 1, 
        display: 'flex', 
        flexDirection: 'column',
        transition: 'all 0.3s ease',
        width: '100%',
        minWidth: 0, // Critical for preventing flexbox overflow
    },
    // This style is applied only on desktop when sidebar is visible
    mainContentDesktop: {
        marginLeft: '260px',
        width: 'calc(100% - 260px)',
    },
    tableContainer: { 
        padding: '20px', 
        backgroundColor: '#fff', 
        margin: '20px', 
        borderRadius: '12px', 
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05)',
    },
    topControls: { 
        display: 'flex', 
        gap: '15px', 
        alignItems: 'center', 
        marginBottom: '20px', 
        flexWrap: 'wrap', 
        justifyContent: 'space-between' 
    },
    headerTitle: { fontSize: '18px', color: '#111827', fontWeight: '600', margin: '0' },
    filterGroup: { display: 'flex', gap: '8px', flexWrap: 'wrap' },
    filterButton: { padding: '8px 16px', borderRadius: '20px', border: '1px solid #D1D5DB', backgroundColor: '#FFFFFF', color: '#6B7280', cursor: 'pointer', fontSize: '13px', transition: '0.2s' },
    filterButtonActive: { backgroundColor: '#E0F2FE', color: '#3B82F6', borderColor: '#3B82F6', fontWeight: '600' },
    filterButtonInactive: { backgroundColor: '#FFFFFF', color: '#6B7280', borderColor: '#D1D5DB' },
    search: { padding: '10px 16px', borderRadius: '8px', border: '1px solid #E5E7EB', width: '100%', maxWidth: '300px', outline: 'none', fontSize: '14px' },
    tableWrapper: { overflowX: 'auto', borderRadius: '12px', border: '1px solid #E5E7EB', backgroundColor: '#fff' },
    table: { width: '100%', borderCollapse: 'collapse' },
    tableHeader: { padding: '16px', textAlign: 'left', fontSize: '13px', color: '#6B7280', backgroundColor: '#F9FAFB', borderBottom: '1px solid #E5E7EB', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.05em' },
    tableCell: { padding: '16px', fontSize: '14px', color: '#374151', borderBottom: '1px solid #F3F4F6' },
    status: { padding: '4px 12px', borderRadius: '999px', fontSize: '12px', fontWeight: '600', display: 'inline-block' },
    pagination: { display: 'flex', justifyContent: 'space-between', marginTop: '20px', alignItems: 'center', padding: '0 10px' },
    paginationButton: { padding: '8px 16px', borderRadius: '8px', border: '1px solid #E5E7EB', backgroundColor: '#fff', cursor: 'pointer', fontSize: '14px' },
    paginationButtonDisabled: { opacity: 0.5, cursor: 'not-allowed' },
    pages: { display: 'flex', gap: '5px' },
    pageNumber: { padding: '8px 12px', borderRadius: '8px', border: '1px solid #E5E7EB', cursor: 'pointer' },
    pageNumberActive: { backgroundColor: '#AE7D54', color: '#fff', borderColor: '#AE7D54' },
    modalOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 2000, padding: '20px' },
    modalContent: { backgroundColor: '#fff', padding: '24px', borderRadius: '16px', width: '100%', maxWidth: '500px', position: 'relative' },
    modalSaveBtn: { padding: '10px 24px', backgroundColor: '#AE7D54', color: '#fff', borderRadius: '8px', border: 'none', cursor: 'pointer', fontWeight: '600' },
    viewIcon: { color: '#3B82F6', cursor: 'pointer', fontSize: '16px' },
    ellipsisIcon: { color: '#6B7280', cursor: 'pointer', fontSize: '16px' },
    deleteIcon: { color: '#EF4444', cursor: 'pointer', fontSize: '16px' },
};